import { FormProvider } from 'react-hook-form';
import { ModalState } from '@sdk/components/ui/modal/useModalState';
import gettext from '@sdk/lang/gettext';
import ProgressButton from '@sdk/components/ui/buttons/ProgressButton';
import { DismissButton } from '@sdk/components/ui/InfoModal/infoInnerModal.styles';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';
import { FormLayout } from '@sdk/components/ui/modalForm/modalForm.styles';

import ShiftTaskIcon from '@web/assets/svg/Icons/32/shift-blue.svg';
import BodyPortal from '@web/components/BodyPortal';
import { TaskTemplateFormValues } from '@web/shiftTasks/ComposeTask/types/TaskTemplateFormValues';
import { TitleField } from '@web/shiftTasks/ComposeTask/TitleField/TitleField';
import { DescriptionField } from '@web/shiftTasks/ComposeTask/DescriptionField/DescriptionField';
import { TaskEditModal } from '@web/shiftTasks/ComposeTask/composeTask.styles';
import { AttachmentsField } from '@web/shiftTasks/ComposeTask/AttachmentsField/AttachmentsField';
import { useShiftTaskAttachmentsFeatureFlag } from '@web/shiftTasks/hooks/useShiftTaskAttachmentsFeatureFlag';
import { TaskTemplate } from '@web/shiftTasks/types/TaskTemplate';
import { SubtasksField } from '@web/shiftTasks/ComposeTask/Subtasks/SubtasksField/SubtasksField';

import { useAddTaskTemplateForm } from './addTaskTemplate.hooks';

export type Props = {
  modalState: ModalState;
  onSubmitSuccess?: (template: TaskTemplate) => void;
  sourceTemplate: TaskTemplateFormValues;
};

export const AddTaskTemplate = (props: Props) => {
  const { areAttachmentsEnabled } = useShiftTaskAttachmentsFeatureFlag();
  const { formMethods, onSubmit } = useAddTaskTemplateForm(props);
  const { modalState } = props;
  const {
    handleSubmit,
    formState: { isSubmitting, isValid },
  } = formMethods;

  return (
    <BodyPortal>
      <TaskEditModal
        titleText={gettext('New task template')}
        titleIcon={<ShiftTaskIcon />}
        dismiss={modalState.close}
        zIndex={1060}
        buttons={
          <>
            <DismissButton onClick={modalState.close}>{gettext('Cancel')}</DismissButton>
            <DismissButton
              as={ProgressButton}
              buttonType={isValid ? ButtonType.primary : ButtonType.disabledStyle}
              onClick={handleSubmit(onSubmit)}
              inactive={!isValid || isSubmitting}>
              {gettext('Create')}
            </DismissButton>
          </>
        }>
        <FormProvider {...formMethods}>
          <form>
            <FormLayout>
              <TitleField />
              <DescriptionField />
              <SubtasksField />
              {areAttachmentsEnabled && <AttachmentsField />}
            </FormLayout>
          </form>
        </FormProvider>
      </TaskEditModal>
    </BodyPortal>
  );
};
